import type { AccentType } from '../../types/AccentType';
import type { ResolvedTheme } from '../../types/ThemeType';

import type { AccentPalette } from './accentPalettes';
import { getAccentPalette } from './accentPalettes';
import type { CssVariableMap } from './types';

export const accentPaletteToCssVariables = (palette: AccentPalette): CssVariableMap => ({
  '--ds-accent': palette.accent,
  '--ds-accent-muted': palette.muted,
  '--ds-accent-subtle': palette.subtle,
  '--ds-accent-on': palette.onAccent,

  '--ds-control-primary-bg': palette.buttonBg,
  '--ds-control-primary-text': palette.onAccent,
  '--ds-control-outline-text': palette.accent,
  '--ds-control-outline-border': palette.accent,
  '--ds-input-border-focus': palette.accent,
  '--ds-hover-primary': palette.outlineHover,
  '--ds-focus-ring': palette.focusRing,
  '--ds-selection': palette.selection,

  '--color-accent-current': palette.accent,
  '--color-accent-primary': palette.accent,
  '--color-border-accent': palette.accent,
  '--color-text-accent': palette.accent,
  '--color-text-on-accent': palette.onAccent,
  '--color-icon-accent': palette.accent,

  '--color-btn-primary-bg': palette.buttonBg,
  '--color-btn-primary-text': palette.onAccent,
  '--color-btn-primary-hover': palette.buttonHover,
  '--color-btn-primary-active': palette.buttonActive,

  '--color-btn-outline-text': palette.accent,
  '--color-btn-outline-border': palette.accent,
  '--color-btn-outline-hover': palette.outlineHover,

  '--color-input-border-focus': palette.accent,

  '--color-hover-primary': palette.outlineHover,
  '--color-focus-ring': palette.focusRing,
  '--color-selection': palette.selection,

  '--color-badge-accent-bg': palette.muted,
  '--color-badge-accent-text': palette.accent,
  '--color-surface-accent-light': palette.subtle,
});

export const accentToCssVariables = (
  accent: AccentType,
  theme: ResolvedTheme
): CssVariableMap => accentPaletteToCssVariables(getAccentPalette(accent, theme));
